import { UUID } from '../helpers';
import { migrateTimestampsFromLegacyUpdatedAt } from '../timestamps';

export const taxonomyProperties = {
  id: {
    type: 'string',
    maxLength: UUID.maxLength,
    final: true
  },
  name: {
    type: 'string'
  },
  behaviours: {
    type: 'array',
    items: { type: 'string' }
  }
};

export const migrationStrategies = {
  1: oldDoc => {
    oldDoc.behaviours = [];
    oldDoc.children &&
      oldDoc.children.forEach(child => (child.behaviours = []));

    return oldDoc;
  },
  2: migrateTimestampsFromLegacyUpdatedAt
};

export default {
  version: 2,
  primaryKey: 'id',
  type: 'object',
  properties: {
    ...taxonomyProperties,
    id: {
      ...taxonomyProperties.id
    },
    updatedAt: {
      type: 'integer'
    },
    lastSyncedAt: {
      type: ['integer', 'null']
    },
    children: {
      type: 'array',
      items: {
        type: 'object',
        properties: taxonomyProperties
      }
    }
  },
  required: ['id', 'name']
};
